import React, { useState } from "react";
import Container from "@mui/material/Container";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Stack from "@mui/material/Stack";
import Card from "@mui/material/Card";
import CardActions from "@mui/material/CardActions";
import CardContent from "@mui/material/CardContent";
import CardMedia from "@mui/material/CardMedia";
import Button from "@mui/material/Button";
import { styled } from "@mui/material/styles";
import Paper from "@mui/material/Paper";
import Grid from "@mui/material/Grid";
import Rating from "@mui/material/Rating";
import { makeStyles } from "@mui/styles";

// Images
import me from "./../../assets/images/newLook.jpeg";
import NestedNavigation from "../NestedNavigation/NestedNavigation";
import SkillsTabsComp from "../skillsTabsComp";

const Item = styled(Paper)(({ theme }) => ({
  ...theme.typography.body2,
  padding: theme.spacing(1),
  textAlign: "center",
  color: theme.palette.text.secondary,
}));

const useStyles = makeStyles({
  mobileFontSize: {
    fontSize: { xs: "2rem", md: "3rem" },
  },
  sectionMargins: {
    margin: "30px 0",
  },
});

function About() {
  const [dense, setDense] = React.useState(false);
  const [secondary, setSecondary] = React.useState(false);
  const [courses, setCourses] = useState([
    {
      imagePath: "https://i.imgur.com/nqTfJWO.jpg",
      name: "CS50x",
      desc: "This was an amazing computer science basices course I have never take before with David Malan",
      courseLink: "https://cs50.harvard.edu/x/2021/",
    },
    {
      imagePath: "https://i.imgur.com/prEE7pw.jpg",
      name: "C++",
      desc: "This was an amazing C++ course I have never take before with Ali Shahin",
      courseLink:
        "https://alishahin.net/Course/CourseDetails/?courseId=6451d218-0690-4301-99f5-87656a5c3209",
    },
    {
      imagePath: "https://i.imgur.com/BQGQ1k0.jpg",
      name: "Angular",
      desc: "This was an amazing Angular.io course I have never take before with Ali Shahin",
      courseLink:
        "https://alishahin.net/Course/CourseDetails/?courseId=defef58b-938f-46c0-b91c-c6d6029e70f3",
    },
  ]);

  const classes = useStyles();

  const [value, setValue] = React.useState(5);

  return (
    <section>
      <Container>
        <NestedNavigation />
        <Box id="about" className={classes.sectionMargins}>
          <Typography
            variant="h2"
            component="h2"
            sx={{
              fontSize: { xs: "2.2rem", md: "3rem" },
              marginBottom: "15px",
            }}
          >
            About
          </Typography>
          <Typography variant="h6" component="p">
            👋 Hi, I am Mohamed Atef, a front-end developer from Egypt. I love
            to learn and discover all things in web development. Makes the web
            an awesome place. I have a passion for learning. I’m dedicated to
            growing this amazing industry in new ways we haven’t seen before.
            Some technologies I enjoy working with include: JavaScript,
            TypeScript, React, Redux Toolkit, Next.js, and Tailwind CSS
          </Typography>
          <figure style={{ width: "20%", margin: "25px 0" }}>
            <img src={me} alt="" style={{ maxWidth: "100%" }} />
          </figure>
          <Typography variant="h6" component="p">
            So, How I get into tech? I actually graduated from the faculty of
            Law In Egypt which is not related to technology at all, but I always
            love to learn new things and develop my self. Naturally, tech was
            the perfect place to be and I`m super passionate about coding. I
            think that's enough to know about me, you can find at the rest of
            this page my skills and interests.
          </Typography>
        </Box>
        {/* Start Skills */}
        <Stack direction="column" className={classes.sectionMargins}>
          <Typography
            id="skills"
            variant="h2"
            sx={{ fontSize: { xs: "2.2rem", md: "3rem" } }}
          >
            Skills
          </Typography>
          <SkillsTabsComp />
        </Stack>
        {/* Start Skills */}
        <Box className={classes.sectionMargins}>
          <Typography
            variant="h2"
            component="h2"
            id="recommendations"
            sx={{ fontSize: { xs: "2.2rem", md: "3rem" } }}
          >
            Recommendations{" "}
            <Typography variant="h6" component="span">
              <sub>Courses &amp; Books</sub>
            </Typography>
          </Typography>
          <Box sx={{ flexGrow: 1, margin: "20px 0" }}>
            <Grid
              container
              spacing={{ xs: 2, md: 3 }}
              columns={{ xs: 1, sm: 2, md: 12 }}
            >
              {courses.map((course, index) => (
                <Grid item xs={1} sm={1} md={4} key={index}>
                  <Item>
                    <Card sx={{ maxWidth: "100%", boxShadow: "none" }}>
                      <CardMedia
                        component="img"
                        height="140"
                        image={course.imagePath}
                        alt="green iguana"
                      />
                      <CardContent>
                        <Typography gutterBottom variant="h5" component="div">
                          {course.name}
                        </Typography>
                        <Typography
                          variant="body2"
                          color="text.secondary"
                          sx={{ marginBottom: "8px" }}
                        >
                          {course.desc}
                        </Typography>
                        <Box
                          sx={{
                            "& > legend": { mt: 2 },
                          }}
                        >
                          <Rating name="read-only" value={value} readOnly />
                        </Box>
                      </CardContent>
                      <CardActions>
                        {/* <Button size="small">Share</Button> */}
                        <Button target="_blank" href={course.courseLink}>
                          Learn More
                        </Button>
                      </CardActions>
                    </Card>
                  </Item>
                </Grid>
              ))}
            </Grid>
          </Box>
        </Box>
      </Container>
    </section>
  );
}

export default About;
